var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-spinner progress-spinner-double progress-spinner-active",class:[_vm.sizeClass]},[_c('div',{staticClass:"progress-spinner-inner"}),_c('div',{staticClass:"progress-spinner-inner"}),_c('span',{staticClass:"sr-only"},[_vm._v("Caricamento...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }